<template>
  <div class="row" v-on:click="returnClick">
    <div class="col-md-2">
      {{ name }}
    </div>
    <div class="col-md-10">
      {{ value }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'simple-row',
  props:{
    name: '',
    value: '',
    firstColumnSize: 2
  },
  data() {
    return {}
  },
  methods: {
    returnClick() {
      this.$emit('clicked');
    }
  }
}
</script>
<style>
</style>
